<template>
  <el-form
    ref="form"
    :model="form"
    :rules="rule"
    label-width="140px"
    style="width:60%;margin:40px auto;"
  >
    <el-form-item label="用户名">
      <el-input v-model="username" disabled></el-input>
    </el-form-item>
    <el-form-item label="旧密码" prop="oldPassword">
      <el-input type="password" v-model="form.oldPassword"></el-input>
    </el-form-item>
    <el-form-item label="新密码" prop="newPassword">
      <el-input type="password" v-model="form.newPassword"></el-input>
    </el-form-item>
    <el-form-item label="确认新密码" prop="password_new_confirm">
      <el-input type="password" v-model="form.password_new_confirm"></el-input>
    </el-form-item>
    <el-form-item>
      <el-button type="primary" @click="saveData" :loading="btnLoading">保存</el-button>
      <el-button @click="cancel">取消</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import { resetPassword } from "@/api/user";
import { getUser } from "@/utils/auth";
import md5 from "js-md5";

export default {
  data() {
    const validatePass = (rule, value, callback) => {
      if (value.length < 6) {
        callback(new Error("密码不能小于6位"));
      } else {
        callback();
      }
    };
    const validatePass2 = (rule, value, callback) => {
      if (value.length < 6) {
        callback(new Error("密码不能小于6位"));
      } else if (value !== this.form.newPassword) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      btnLoading: false,
      username: getUser() && Object.keys(getUser()).length !== 0 ? getUser().name : "",
      form: {
        oldPassword: "",
        newPassword: "",
        password_new_confirm: ""
      },
      rule: {
        oldPassword: [{ required: true, trigger: "blur", message: "旧密码不能为空" }],
        newPassword: [{ required: true, trigger: "blur", validator: validatePass }],
        password_new_confirm: [{ required: true, trigger: "blur", validator: validatePass2 }]
      }
    };
  },
  created() {},
  methods: {
    saveData() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          this.btnLoading = true;
          const params = {
            oldPassword: md5(this.form.oldPassword),
            newPassword: md5(this.form.newPassword)
          };
          resetPassword(params)
            .then(resp => {
              if (resp && resp.bizcode == 100) {
                this.$notify({
                  title: "成功",
                  message: "保存成功",
                  type: "success",
                  duration: 2000
                });
                setTimeout(() => {
                  this.$router.go(-1); //返回上一层
                }, 500);
              }
            })
            .finally(() => {
              this.btnLoading = false;
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    cancel() {
      this.$router.go(-1); //返回上一层
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped></style>
